import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface JournalIdentifier {
  id?: string;
  isbn?: string | null;
  issn?: string | null;
}

export function isJournalBiblio(biblio: JournalIdentifier) {
  return Boolean(biblio.issn && !biblio.isbn);
}

export function JournalDetailsBridge({ biblio }: { biblio: JournalIdentifier }) {
  if (!biblio.id || !isJournalBiblio(biblio)) return null;

  return (
    <Button asChild variant="outline">
      <Link to={`/catalog/journal/${biblio.id}`}>View journal holdings</Link>
    </Button>
  );
}
